import React, { ReactNode } from 'react'

export const containerWidthClass = `max-w-app`

export function Container({ children, className }: { children: ReactNode; className?: string }) {
    return <div className={`${containerWidthClass} mx-auto px-0 ${className}`}>{children}</div>
}
